const { doc } = require("prettier");

const programNav = document.getElementById("program-nav");
var stickyItem = document.getElementById("program-sticky-item");

let prevScrollpos = 0;
let up = false;

const navItems = document.querySelectorAll("[data-display-in-nav]");

function repeatOften() {

    if (!programNav) {
        return;
    }

    for(var i = 0; i < navItems.length; i++) {
        if (navItems[i].getBoundingClientRect().top <= 0 && navItems[i + 1].getBoundingClientRect().top > 0) {
            if(navItems[i].firstElementChild.innerText != stickyItem.innerText) {
                stickyItem.removeChild(stickyItem.firstChild);
                stickyItem.appendChild(navItems[i].firstElementChild.cloneNode(true));
            }
        }
        else if (navItems[i].getBoundingClientRect().top <= 0 && (i + 2 == navItems.length)) {
            i++;
            if(navItems[i].firstElementChild.innerText != stickyItem.innerText) {
                stickyItem.removeChild(stickyItem.firstChild);
                stickyItem.appendChild(navItems[i].firstElementChild.cloneNode(true));
                break;
            }
        }
    }

    let navPos = programNav.getBoundingClientRect()
    if (!programNav.classList.contains("program__navigation--top") && navPos.top <= 0) {
        programNav.classList.add("program__navigation--top");
    }
    if (programNav.classList.contains("program__navigation--top") && navPos.top > 0) {
        programNav.classList.remove("program__navigation--top");
    }

  requestAnimationFrame(repeatOften);
}
requestAnimationFrame(repeatOften);
